import { call, put, takeLatest } from "redux-saga/effects";
import {
  DROPDOWN_CACHE,
  RULE_LIST,
  ESCALATION_RULE_ADD_DATA,
  ESCALATION_RULE_POST_API,
  RULE_LIST_API,
  RULE_LIST_DELETE_API,
  CATEGORY_DROPDOWN_API,
  STATUS_DROPDOWN_API,
  NOTIFICATION_VARIABLES_API,
  NOTIFICATION_VARIABLES,
  STATUS_DROPDOWN,
  CATEGORY_DROPDOWN,
  ESCALATION_GET_DATA,
  ESCALATION_GET_DETAIL_API,
  ESCALATION_RULE_UPDATE_API,
  ESCALATION_RULE_UPDATE,
  ESCALATION_EXECUTIONS_GET_API,
  ESCALATION_EXECUTIONS_GET_ROW_COUNT_API,
  ESCALATION_EXECUTIONS_GET
} from "./Constants";

import {
  setEscalationRuleAddSuccess,
  setEscalationRuleAddFail,
  setDropdownCacheSuccess,
  setDropdownCacheFail,
  setRuleListSuccess,
  setRuleListFail,
  setRuleListDeleteFail,
  setRuleListDeleteSuccess,
  setCategoryDropdownSuccess,
  setCategoryDropdownFail,
  setStatusDropdownSuccess,
  setStatusDropdownFail,
  setNotificationVariablesSuccess,
  setNotificationVariablesFail,
  ruleListRequest,
  setEscalationGetDataFail,
  setEscalationGetDataSuccess,
  setEscalationRuleUpdateSuccess,
  setEscalationRuleUpdateFail,
  setEscalationExecutionListSuccess,
  setEscalationExecutionListFail,
  setEscalationExecutionListRowCountSuccess,
  setEscalationExecutionListRowCountFail
} from "./Actions";

import { addSuccessAlert, addErrorAlert } from "../../../../../src/containers/alert/Actions"
import { deleteLocalEscalationRuleRequest, ticketApi } from "../../../../shared/components/Service";
import { normalizeDropdownResponse } from "./dropdownUtils";

function* postEscalationRuleService({ request }) {
  try {
    // let requestData = {
    //   to_insert: request,
    // };

    const response = yield call(ticketApi.post, ESCALATION_RULE_POST_API, request);

    if (response.status === 201) {
      yield put(addSuccessAlert("Escalation rule created successfully"));
      yield put(setEscalationRuleAddSuccess(response.data));
    } else {
      yield put(addErrorAlert(response.response.data.msg || "Failed to create rule"));
      yield put(setEscalationRuleAddFail(response.response.data));
    }
  } catch (error) {
    yield put(addErrorAlert("Could not create escalation rule"));
    yield put(setEscalationRuleAddFail(error));
  }
}

function* fetchDropdownCacheSaga({ endpoint }) {
  try {
    const response = yield call(ticketApi.get, endpoint);

    let data = response.data;

    // Normalize like your component does (optional refinement)
    if (data?.data && Array.isArray(data.data)) {
      data = data.data;
    }

    // Normalize response using the same logic used earlier
    const finalOptions = normalizeDropdownResponse(data, endpoint);

    yield put(setDropdownCacheSuccess(endpoint, finalOptions));
  } catch (error) {
    yield put(addErrorAlert(`Failed to load dropdown: ${endpoint}`));
    yield put(setDropdownCacheFail(endpoint, error));
  }
}

function* fetchRuleListSaga() {
  try {
    //TODO: Remove this once api is fixed
    const response = yield call(ticketApi.get, RULE_LIST_API);
    let data = response.data;
    yield put(setRuleListSuccess(data));
  } catch (error) {
    yield put(addErrorAlert(`Failed to load rule list: ${RULE_LIST_API}`));
    yield put(setRuleListFail(error));
  }
}


function* getCategoriesDropdownService(action) {
  try {
    const { includeQuestions, questionId, companyId } = action.payload || {};

    const params = new URLSearchParams();
    if (includeQuestions) params.append("includeQuestions", true);
    if (questionId)       params.append("question_id", questionId);
    if (companyId)        params.append("company_id", companyId);

    const qs = params.toString() ? `?${params.toString()}` : "";
    const url = `${CATEGORY_DROPDOWN_API}${qs}`;

    const response = yield call(ticketApi.get, url);
    const status = response.status;

    if (status === 200) {
      const raw = response.data.data || [];
      const formatted = raw.map((item) => ({
        value: item.id,
        label: item.name,
        company_id: item.company_id ?? null,
        default_admin_group_id: item.default_admin_group_id,
        ticket_type: item.ticket_type,
        default_administrator_id: item.default_administrator_id || null,
        questions: item.questions || null,
      }));
      yield put(setCategoryDropdownSuccess(formatted));
    } else {
      yield put(setCategoryDropdownFail(response?.response?.data?.msg || "Failed to load categories"));
    }
  } catch (error) {
    yield put(setCategoryDropdownFail(error));
  }
}


function* getStatusDropdownService() {
  try {
    const response = yield call(ticketApi.get, STATUS_DROPDOWN_API);
    const status = response.status;

    if (status === 200) {
      const raw = response.data.data || [];

      const formatted = raw.map((item) => ({
        value: item.id,
        label: item.status_name,
        code: item.status_code,
      }));

      yield put(setStatusDropdownSuccess(formatted));
    } else {
      yield put(setStatusDropdownFail(response?.response?.data?.msg || "Failed to load statuses"));
    }
  } catch (error) {
    yield put(setStatusDropdownFail(error));
  }
}

function* getNotificationVariablesService() {
  try {
    const response = yield call(ticketApi.get, NOTIFICATION_VARIABLES_API);
    const status = response.status;

    if (status === 200) {
      const data = response.data.data || [];
      const formatted = data.map(v => v.variable_code);
      yield put(setNotificationVariablesSuccess(formatted));
    } else {
      yield put(setNotificationVariablesFail(response?.response?.data?.msg || "Failed to load notification variables"));
    }
  } catch (error) {
    yield put(setNotificationVariablesFail(error));
  }
}


export function* getEscalationDataService({ id }) {
  try {
    const response = yield call(ticketApi.getDetail, ESCALATION_GET_DETAIL_API + id);
    const status = response.status;

    if (status === 200) {
      const data = response.data;
      yield put(setEscalationGetDataSuccess(data));
    } else {
      yield put(setEscalationGetDataFail(response?.response?.data));
    }
  } catch (error) {
    yield put(setEscalationGetDataFail(error));
  }
}

function* putEscalationRuleUpdateService({ id, request }) {

  try {
    const response = yield call(ticketApi.put, `${ESCALATION_RULE_UPDATE_API}${id}`, request);
   
    const status = response?.status;

    if (status === 200) {
      yield put(addSuccessAlert("Escalation rule updated successfully"));
      yield put(setEscalationRuleUpdateSuccess(response.data));
    } else {
      yield put(
        addErrorAlert(response?.response?.data?.msg || "Failed to update rule")
      );
      yield put(setEscalationRuleUpdateFail(response?.response?.data));
    }
  } catch (error) {
    yield put(addErrorAlert("Failed to update escalation rule"));
    yield put(setEscalationRuleUpdateFail(error));
  }
}

export function* watchTicketingDropdowns() {
  yield takeLatest(CATEGORY_DROPDOWN.LOAD, getCategoriesDropdownService);
  yield takeLatest(STATUS_DROPDOWN.LOAD, getStatusDropdownService);
  yield takeLatest(NOTIFICATION_VARIABLES.LOAD, getNotificationVariablesService);
}

export function* watchEscalationDataService() {
  yield takeLatest(ESCALATION_GET_DATA.ESCALATION_GET_DATA_LOAD, getEscalationDataService);
}

// For update escalation rule
export function* watchEscalationRuleUpdateService() {
  yield takeLatest(ESCALATION_RULE_UPDATE.ESCALATION_RULE_UPDATE_LOAD, putEscalationRuleUpdateService);
}

function* deleteRuleSaga({ request }) {
  try {
    //TODO: Remove this once api is fixed
    const response = yield call(deleteLocalEscalationRuleRequest, RULE_LIST_DELETE_API, request);
    if (response.status === 200) {
      yield put(addSuccessAlert(response.data.message || "Rule deleted successfully"));
      yield put(setRuleListDeleteSuccess(response.data));
      yield put(ruleListRequest());
    } else {
      yield put(addErrorAlert(response.data.message || "Failed to delete rule"));
      yield put(setRuleListDeleteFail(response.data));
    }
  } catch (error) {
    yield put(addErrorAlert("Failed to delete rule"));
    yield put(setRuleListDeleteFail(error));
  }
}

function* getEscalationExecutionListSaga({payload}) {

  console.log("payload--",payload)
  try {
    const response = yield call(ticketApi.post, ESCALATION_EXECUTIONS_GET_API, payload);
    const status = response.status;

    if (status === 200) {
      const data = response.data.data || [];
      yield put(setEscalationExecutionListSuccess(data));
    } else {
      yield put(setEscalationExecutionListFail(response?.response?.data));
    }
  } catch (error) {
    yield put(setEscalationExecutionListFail(error));
  }
}

function* getEscalationExecutionListRowCountSaga({payload}) {
  try {
    const response = yield call(ticketApi.post, ESCALATION_EXECUTIONS_GET_ROW_COUNT_API, payload);
    const status = response.status;

    if (status === 200) {
      const data = response.data || [];
      yield put(setEscalationExecutionListRowCountSuccess(data));
    } else {
      yield put(setEscalationExecutionListRowCountFail(response?.response?.data));
    }
  } catch (error) {
    yield put(setEscalationExecutionListRowCountFail(error));
  }
}

export function* watchEscalationExecutionList() {
  yield takeLatest(ESCALATION_EXECUTIONS_GET.ESCALATION_EXECUTIONS_GET_LOAD, getEscalationExecutionListSaga);
  yield takeLatest(ESCALATION_EXECUTIONS_GET.ESCALATION_EXECUTIONS_GET_ROW_COUNT, getEscalationExecutionListRowCountSaga);
}

export function* watchRuleList() {
  yield takeLatest(RULE_LIST.RULE_LIST_LOAD, fetchRuleListSaga);
  yield takeLatest(RULE_LIST.RULE_LIST_DELETE, deleteRuleSaga);
}

export function* watchDropdownCache() {
  yield takeLatest(DROPDOWN_CACHE.DROPDOWN_CACHE_LOAD, fetchDropdownCacheSaga);
}

export function* watchEscalationRule() {
  yield takeLatest(
    ESCALATION_RULE_ADD_DATA.ESCALATION_RULE_ADD_DATA_LOAD,
    postEscalationRuleService
  );
}
